import { connect } from 'react-redux';

import type { RootReducerStateT } from 'app/reducers/rootReducer';

import { selectQueueState } from '../../../../app/utils/reselect';
import ContactForm from '../../components/modals/contactform';
import { FlowChatNodeContactFormT } from '../../components/nodeTypes/contactform';

export type ContactFormModalStatePropsT = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (
  state: RootReducerStateT,
  ownProps: { node: FlowChatNodeContactFormT },
) => ({
  queuesState: selectQueueState(state),
  initialValues: ownProps.node,
  fromEmails: state.composeEmail.fromEmails,
});

export default connect(mapStateToProps)(ContactForm);
